import * as React from 'react'
import './index.less'

export const TimePickerFieldInputTrigger = ({
	value,
	lastSelectedValue,
	validateTimeFn,
	setValue,
	setOpen,
	onChange,
	placeholder,
	onClick,
	onBlur,
	disabled,
	// Ark UI props need to be forwarded for the trigger to function
	...triggerProps
}) => {
	const [draftValue, setDraftValue] = React.useState(value)

	React.useEffect(() => {
		setDraftValue(value)
	}, [value])

	const handleChange = newValue => {
		setDraftValue(newValue)

		if (newValue === '' || validateTimeFn(newValue)) onChange(newValue)
	}

	const handleBlur = event => {
		if (draftValue !== '' && !validateTimeFn(draftValue)) setDraftValue(value)

		onBlur?.(event)
	}

	const handleClick = event => {
		// Prevent buildField from clicking the trigger again while the event bubbles.
		event.stopPropagation()
		onClick?.(event)
	}

	const handleKeyDown = event => {
		if (event.key === 'Enter') {
			setValue(lastSelectedValue)
			setOpen(false)
		}
	}

	return (
		<input
			{...triggerProps}
			type="text"
			className="time-picker-field-trigger form-field-value-label"
			value={draftValue}
			placeholder={placeholder}
			maxLength={5}
			onChange={e => handleChange(e.target.value)}
			onBlur={handleBlur}
			onClick={handleClick}
			disabled={disabled}
			onKeyDown={handleKeyDown}
		/>
	)
}
